interface HeaderMenuProps {
  className?: string
}

export const HeaderMenu = ({ className }: HeaderMenuProps) => {
  return (
    <img
      src='/assets/icons/header/menu-bar.svg'
      alt='bar'
      className={className}
    />
  )
}
